import { Alert, Button, Group, Stack } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useCallback, useState } from 'react';

export const QRCode = ({ name, data }: { name?: string; data: string }) => {
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(false);

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(
    data,
  )}`;

  const downloadQRCode = useCallback(async () => {
    if (!data) return setError(true);

    try {
      setFetching(true);

      // 1. Fetch the PNG *with CORS*.
      const res = await fetch(qrUrl, { mode: 'cors', cache: 'no-cache' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      // 2. Turn it into a local object URL.
      const blobURL = URL.createObjectURL(await res.blob());

      // 3. Trigger download from *your* origin.
      const a = document.createElement('a');
      a.href = blobURL;
      a.download = `${name || 'qr-code'}.png`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // 4. Clean up.
      URL.revokeObjectURL(blobURL);
    } catch {
      setError(true);
    } finally {
      setFetching(false);
    }
  }, [qrUrl, data, name]);

  return (
    <Stack gap='sm'>
      <Group gap='md' align='center'>
        <img
          src={qrUrl}
          height={132}
          width={132}
          alt={`QR code for ${name || 'the listener page'}`}
          style={{ borderRadius: 8, background: 'white', padding: 6 }}
        />
        <Button
          onClick={downloadQRCode}
          loading={fetching}
          variant='light'
          color='indigo'
          size='sm'
          leftSection={<IconDownload size={16} />}
        >
          Download QR code
        </Button>
      </Group>

      {error && (
        <Alert title='Error' color='red'>
          There was an error downloading the QR code.
        </Alert>
      )}
    </Stack>
  );
};
